export default {
	monitorTrack:{
		eventid: "15077",
		category: "monitor-error",
		action: "monitor-catch-error",
		label: "全局错误监控统计",
		value: ""
	}
}